"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextContainer = exports.HelpText = void 0;
var typography_1 = require("../../../components/typography");
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
var TextSize_1 = require("./TextSize");
exports.HelpText = (0, styled_components_1.default)(typography_1.BodyText).attrs(function () { return ({}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  margin-top: ", ";\n"], ["\n  font-size: ", ";\n  margin-top: ", ";\n"])), function (_a) {
    var $size = _a.$size;
    return (0, polished_1.rem)(TextSize_1.TextSize[$size]);
}, (0, polished_1.rem)(4));
exports.TextContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), (0, polished_1.rem)(12));
var templateObject_1, templateObject_2;
